<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="fullexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Summary report</small
                >
              </legend>
              <form @submit.prevent="loadFullExpense()">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control Ufrom_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control Uend_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Transporter</label>
                      <select class="form-control transporter_id">
                        <option value>select Transporter</option>
                        <option
                          v-for="transporter in systemTransporters"
                          :value="transporter.id"
                          :key="transporter.id"
                        >
                          {{ transporter.transporter_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingFullexpense"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingFullexpenseLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      id="weeklyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Summary report</small
                >
              </legend>
              <form @submit.prevent="loadtruckExpense()">
                <div class="row">
                  <input type="hidden" class="truck_id" :value="Truck.id" />
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingTruckexpense"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingTruckexpenseLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      id="tripModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Trip Summary report</small
                >
              </legend>
              <form @submit.prevent="loadTrucktrips()">
                <div class="row">
                  <input type="hidden" class="truck_id" :value="Truck.id" />
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control Ufrom_Date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control Uend_Date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingTrucktrip"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingTrucktripLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Truck summary</div>
            <fieldset class="border p-3">
              <button
                type="button"
                class="btn btn-success btn-roundec"
                data-toggle="modal"
                data-target="#fullexpensesModal"
              >
                <i class="fa fa-file-pdf-o"></i> General summary
              </button>
              <p></p>
              <div></div>
              <div>
                <div class="trucksLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading trucks...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemTrucks"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'faulty_status'">
                      <span v-if="props.row.Faulty_status === 0">
                        <button class="btn btn-info btn-sm btn-flat">
                          <i class="fa fa-level-up"></i> NOT FAULTY
                        </button>
                      </span>
                      <span v-else-if="props.row.Faulty_status === 1">
                        <button class="btn btn-danger btn-sm">
                          <i class="fa fa-level-down"></i> FAULTY
                        </button>
                      </span>
                    </span>

                    <span v-if="props.column.field == 'Action'">
                      <button
                        type="button"
                        class="btn btn-primary btn-roundec"
                        data-toggle="modal"
                        data-target="#weeklyexpensesModal"
                        @click="viewTrucks(props.row.id)"
                      >
                        <i class="fa fa-file-pdf-o"></i> Truck summary
                      </button>
                    </span>
                    <span v-if="props.column.field == 'Trip'">
                      <button
                        type="button"
                        class="btn btn-info btn-roundec"
                        data-toggle="modal"
                        data-target="#tripModal"
                        @click="viewTrucktrips(props.row.id)"
                      >
                        <i class="fa fa-file-pdf-o"></i> Trip summary
                      </button>
                    </span>
                    <span v-else>{{
                      props.formattedRow[props.column.field]
                    }}</span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Transporter name",
          field: "transporter_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter transporter",
          },
        },
        {
          label: "Truck number",
          field: "truck_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter truck number",
          },
        },
        {
          label: "Trailer number",
          field: "trailer_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter trailer no",
          },
        },
        {
          label: "Driver name",
          field: "driver_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter driver name",
          },
        },
        {
          label: "Driver phone",
          field: "driver_phone",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter driver phone",
          },
        },
        {
          label: "Id number",
          field: "driver_id_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter driver id/passport no",
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
        },
        {
          label: "Trip",
          field: "Trip",
          width: "122px",
          html: true,
        },
      ],
    };
  },
  created() {
    this.loadTrucks();
    this.loadTransporters();
  },
  computed: {
    ...mapGetters(["systemTrucks", "Truck", "systemTransporters"]),
  },
  methods: {
    ...mapActions([
      "loadTrucks",
      "viewTrucks",
      "loadtruckExpense",
      "loadfullExpenses",
      "loadFullExpense",
      "loadTransporters",
      "viewTrucktrips",
      "loadTrucktrips",
    ]),
  },
};
</script>
<style scoped>
.creatingTruckexpenseLoader {
  display: none;
}
.creatingFullExpensesLoader {
  display: none;
}
.creatingFullexpenseLoader {
  display: none;
}
.creatingTrucktripLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/reports/summary.vue